/* eslint-disable  */
console.log("IMPORT ALL DEPENDENCIES...");

// Arduino generator core
// import initArduino, {profile, img_path}  from "./generator/arduino";
import initArduino  from "./generator/arduino";

// Arduino blocks definition
import initLogicBlock from "./blocks/block-logic";
import initControlBlock from "./blocks/block-control";
import initMathBlock from "./blocks/block-math";
import initTextBlock from "./blocks/block-text";
import initVariablesBlock from "./blocks/block-variables";
import initListsBlock from "./blocks/block-lists";
import initProceduresBlock from "./blocks/block-procedures";
import initIOBlock from "./blocks/block-io";
import initTimeBlock from "./blocks/block-time";
import initSerialBlock from "./blocks/block-serial";
import initBluetoothBlock from "./blocks/block-bluetooth";
import initSensorsBlock from "./blocks/block-sensors";
import initActuatorsBlock from "./blocks/block-actuators";
import initLCDBlock from "./blocks/block-lcd";
import initMotorBlock from "./blocks/block-motor";
import initRTCBlock from "./blocks/block-rtc";
import initSDBlock from "./blocks/block-sd";
import initMQTTBlock from "./blocks/block-mqtt";
import initBLYNKBlock from "./blocks/block-blynk";
import initNeopixelBlock from "./blocks/block-neopixel";
import initMatrixBlock from "./blocks/block-matrix";
import initColourBlock from "./blocks/block-colour";
import initIRBlock from "./blocks/block-infrared";
import initThingspeakBlock from "./blocks/block-thigspeak";
import initThingerBlock from "./blocks/block-thinger";
import initIFTTTBlock from "./blocks/block-ifttt";

// Code generators for each block
import initLogicGenerator from "./generator/arduino/generator-logic";
import initControlGenerator from "./generator/arduino/generator-control";
import initMathGenerator from "./generator/arduino/generator-math";
import initTextGenerator from "./generator/arduino/generator-text";
import initVariablesGenerator from "./generator/arduino/generator-variables";
import initListsGenerator from "./generator/arduino/generator-lists";
import initProceduresGenerator from "./generator/arduino/generator-procedures";
import initIOGenerator from "./generator/arduino/generator-io";
import initTimeGenerator from "./generator/arduino/generator-time";
import initSerialGenerator from "./generator/arduino/generator-serial";
import initBluetoothGenerator from "./generator/arduino/generator-bluetooth";
import initSensorsGenerator from "./generator/arduino/generator-sensors";
import initActuatorsGenerator from "./generator/arduino/generator-actuators";
import initLCDGenerator from "./generator/arduino/generator-lcd";
import initMotorGenerator from "./generator/arduino/generator-motor";
import initRTCGenerator from "./generator/arduino/generator-rtc";
import initSDGenerator from "./generator/arduino/generator-sd";
import initMQTTGenerator from "./generator/arduino/generator-mqtt";
import initBLYNKGenerator from "./generator/arduino/generator-blynk";
import initNeopixelGenerator from "./generator/arduino/generator-neopixel";
import initMatrixGenerator from "./generator/arduino/generator-matrix";
import initColourGenerator from "./generator/arduino/generator-colour";
import initIRGenerator from "./generator/arduino/generator-infrared";
import initThingerGenerator from "./generator/arduino/generator-thinger";
import initThingspeakGenerator from "./generator/arduino/generator-thingspeak";
import initIFTTTGenerator from "./generator/arduino/generator-ifttt";

// eslint-disable-next-line no-unused-vars
// export {img_path, profile};
export function init(externalBlockly, FieldGridDropdown) {
  const [profile, img_path] = initArduino(externalBlockly);
  initLogicBlock(externalBlockly, profile, img_path);
  initControlBlock(externalBlockly, profile, img_path);
  initMathBlock(externalBlockly, profile, img_path);
  initTextBlock(externalBlockly, profile, img_path);
  initVariablesBlock(externalBlockly, profile, img_path);
  initListsBlock(externalBlockly, profile, img_path);
  initProceduresBlock(externalBlockly, profile, img_path);
  initIOBlock(externalBlockly, profile, img_path);
  initTimeBlock(externalBlockly, profile, img_path);
  initSerialBlock(externalBlockly, profile, img_path);
  initBluetoothBlock(externalBlockly, profile, img_path);
  initSensorsBlock(externalBlockly, profile, img_path);
  initActuatorsBlock(externalBlockly, profile, img_path);
  initLCDBlock(externalBlockly, profile, img_path);
  initMotorBlock(externalBlockly, profile, img_path);
  initRTCBlock(externalBlockly, profile, img_path);
  initSDBlock(externalBlockly, profile, img_path);
  initMQTTBlock(externalBlockly, profile, img_path);
  initBLYNKBlock(externalBlockly, profile, img_path);
  initNeopixelBlock(externalBlockly, profile, img_path);
  initMatrixBlock(externalBlockly, profile, img_path, FieldGridDropdown);
  initColourBlock(externalBlockly, profile, img_path);
  initIRBlock(externalBlockly, profile, img_path);
  initThingerBlock(externalBlockly, profile, img_path);
  initThingspeakBlock(externalBlockly, profile, img_path);
  initIFTTTBlock(externalBlockly, profile, img_path);

  initLogicGenerator(externalBlockly, profile);
  initControlGenerator(externalBlockly, profile);
  initMathGenerator(externalBlockly, profile);
  initTextGenerator(externalBlockly, profile);
  initVariablesGenerator(externalBlockly, profile);
  initListsGenerator(externalBlockly, profile);
  initProceduresGenerator(externalBlockly, profile);
  initIOGenerator(externalBlockly, profile);
  initTimeGenerator(externalBlockly, profile);
  initSerialGenerator(externalBlockly, profile);
  initBluetoothGenerator(externalBlockly, profile);
  initSensorsGenerator(externalBlockly, profile);
  initActuatorsGenerator(externalBlockly, profile);
  initLCDGenerator(externalBlockly, profile);
  initMotorGenerator(externalBlockly, profile);
  initRTCGenerator(externalBlockly, profile);
  initSDGenerator(externalBlockly, profile);
  initMQTTGenerator(externalBlockly, profile);
  initBLYNKGenerator(externalBlockly, profile);
  initNeopixelGenerator(externalBlockly, profile);
  initMatrixGenerator(externalBlockly, profile);
  initColourGenerator(externalBlockly, profile);
  initIRGenerator(externalBlockly, profile);
  initThingerGenerator(externalBlockly, profile);
  initThingspeakGenerator(externalBlockly, profile);
  initIFTTTGenerator(externalBlockly, profile);
  // initBluetoothGenerator(externalBlockly, profile);
  // eslint-disable-next-line no-debugger
  // debugger;
  // console.log('=== Blockly ' + JSON.stringify(Blockly));
  // console.log('=== external Blockly ' + JSON.stringify(externalBlockly));
}
